import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface UserInfo {
  [key: string]: any
}

interface UsersState {
  active: number
  genreports: any[]
  tabItems: any[]
  reports: any[]
  userId: string
  isAdmin: boolean
  isInternal: boolean
  userInfo: UserInfo[]
}

const initialState: UsersState = {
  active: 3,
  genreports: [],
  tabItems: [],
  reports: [],
  userId: '12038889',
  isAdmin: false,
  isInternal: false,
  userInfo: []
}

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    addtablist(state, action: PayloadAction<any[]>) {
      state.tabItems = action.payload
    },
    updateReportsData(state, action: PayloadAction<any[]>) {
      state.reports = action.payload
    },
    updategenreports(state, action: PayloadAction<any[]>) {
      state.genreports = action.payload
    },
    updateuser(state, action: PayloadAction<UserInfo[]>) {
      state.userInfo = action.payload
    },
    updateAdmin(state, action: PayloadAction<boolean>) {
      state.isAdmin = action.payload
    },
    updateIsInternal(state, action: PayloadAction<boolean>) {
      state.isInternal = action.payload
    }
  }
})

export const {
  addtablist,
  updateReportsData,
  updategenreports,
  updateuser,
  updateAdmin,
  updateIsInternal
} = usersSlice.actions

export default usersSlice.reducer
